import { useService } from '@policoders/di';
import { Link } from 'react-router-dom';

import logo from '../../../assets/images/logo-web.png';
import NavbarService from './navbar.service';

const LogoAndToggle = () => {
  const navbar = useService<NavbarService>('NavbarService');

  return (
    <>
      <Link className="navbar-brand flex-grow-1 align-items-center d-flex" to="/">
        <img src={logo} alt="BeHold" height={40} />
        <span className="module">{navbar.module}</span>
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#mainNavbar"
        aria-controls="mainNavbar"
        aria-expanded="true"
        aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
    </>
  );
};

export { LogoAndToggle };
